export default [
  {
    path: "/admin_textconfig",
    name: "admin_textconfig",
    component: () => import("./TextConfigurationView"),
    meta: {
      tabAccess: "ADMIN",
    },
  },
  {
    path: "/admin_textconfig/:groupkey/:refkey",
    name: "admin_textconfig_edit",
    component: () => import("./EditTextConfiguration"),
    meta: {
      tabAccess: "ADMIN",
    },
  },
  {
    path: "/admin_textconfig/trip_inclusions",
    name: "admin_trip_inclusions_edit",
    component: () => import("./EditTripInclusions"),
    meta: {
      tabAccess: "ADMIN",
    },
  },
];
